<template>
  <div class="page-container">
    <div class="header">
      <div class="title">清算文件</div>
    </div>
    <div class="search-form">
      <el-form inline class="inline-form" label-width="100px">
        <el-form-item label="创建时间" size="small">
          <el-date-picker
            v-model="dateTimeRange"
            :picker-options="pickerOptions"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            size="small"/>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleFormSearch" class="bs-btn">查询</el-button>
          <el-button type="primary" @click="handleFormReset" class="bs-btn2">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column
          v-for="(item, index) in table.columns"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :formatter="item.formatter"
          :min-width="item.minWidth || 150"
          align="center"
        />
        <!-- <el-table-column prop="createTime" label="创建时间" align="center" min-width="130px"/>
        <el-table-column prop="latestDownloadTime" label="更新时间" align="center" min-width="130px">
          <template slot-scope="{row}">{{ row.latestDownloadTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="reportTypeName" label="报表类型" align="center" min-width="120px"/>
        <el-table-column prop="fileName" label="报表名称" align="center" min-width="150px"/>
        <el-table-column prop="status" label="生成状态" align="center" min-width="80px">
          <template slot-scope="{row}">{{ row.status | statusFilters }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" min-width="200px">
          <template slot-scope="{row}">{{ row.remark || '-' }}</template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" min-width="120px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleTableDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { queryLiquidationDocList, downLoadLiquidationDoc } from "@/api/liquidation-doc";
import { newHost } from "@/global-config";

const FORMAT_YMD = 'yyyy-MM-DD';
const FORMAT_YM = 'yyyy-MM';
const today = moment().format(FORMAT_YMD);
const oneYearAgo = moment().subtract(1, 'year').format(FORMAT_YMD);
const startTime = '00:00:00';
const endTime = '23:59:59';
const defaultTime = [`${oneYearAgo} ${startTime}`, `${today} ${endTime}`];
export default {
  name: "liquidation-doc",
  data() {
    return {
      dateTimeRange: defaultTime,
      pickerOptions: {
        disabledDate(time) {
          // const dayOf1yearAgo = moment(moment().subtract(1, "year").format(FORMAT_YMD)).valueOf();
          return time < oneYearAgo.valueOf() || time > moment(`${today} ${endTime}`).valueOf();
        },
      },
      mapBillType: { 0: '交易结算对账单' },
      table: {
        data: [],
        columns: [
          { label: '报表类型', prop: 'billType', formatter: item => this.mapBillType[item.billType] },
          { label: '报表名称', prop: 'billName', minWidth: 200 },
          { label: '创建时间', prop: 'createTime', minWidth: 130 },
          { label: '更新时间', prop: 'createTime', minWidth: 130 },
          { label: '生成状态', prop: '', formatter: item => '生成成功' },
        ],
        loading: false,
        totalCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    loginInfo() {
      const info = localStorage.getItem('LOGIN_INFO');
      return info ? JSON.parse(info) : {};
    },
  },
  mounted() {
    this.queryTableData();
  },
  methods: {
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.dateTimeRange = defaultTime;
    },
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    queryTableData() {
      const [startTime, endTime] = this.dateTimeRange || [];
      if (!startTime || !endTime) {
        this.$message.warning('请选择交易创建时间');
        return;
      }
      const { pageNo, pageSize } = this.table;
      const params = {
        startTime,
        endTime,
        pageNo,
        pageSize,
      };
      this.table.loading = true;
      queryLiquidationDocList(params).then(({ data: { code, data } }) => {
        if (String(code) === '0') {
          this.table.data = data.list;
          this.table.totalCount = data.totalCount;
        }
      }).finally(() => { this.table.loading = false; });
    },
    handleTableDownload({ billName, serialNo }) {
      const { userName, sessionId } = this.loginInfo;
      window.open(`${newHost}/merchantFranchisee/download?billName=${billName}&serialNo=${serialNo}&userName=${userName}&sessionId=${sessionId}`);
      // downLoadLiquidationDoc({ billName, serialNo }).then(({ data: { code, data, msg } }) => {
      //   if (String(code) !== '0') {
      //     this.$message.console.error(msg);
      //   }
      // });
    },
  },
};
</script>

<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;
  }

  .table-container {
    padding: 40px 50px;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>
